import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DentistNavbar1 from './components/Dentist Navbar/DentistNavbar1';
import DentistHero1 from './components/Dentist Hero/DentistHero1';
import Services from './components/Services/Services';
import OurWork from './components/OurWork/OurWork';
import Testimonials from './components/Testimonials/Testimonials';
import OurTeam from './components/OurTeam/OurTeam';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import ServiceDetail from './components/ServiceDetail/ServiceDetail';
import ScrollToTop from './components/ScrollToTop';


// Pages
import OurTeamPage from './pages/OurTeamPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ServicesPage from './pages/ServicesPage';
import AppointmentPage from './pages/AppointmentPage';
import ContactPage from './pages/ContactPage';
import WriteForUsPage from './pages/WriteForUsPage';

// Home page component
const HomePage = () => (
  <>
    <DentistHero1 />
    <Services />
    <OurWork />
    <Testimonials />
    <OurTeam />
    <Contact />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <DentistNavbar1 />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/service/:serviceId" element={<ServiceDetail />} />
          <Route path="/our-team" element={<OurTeamPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/appointment" element={<AppointmentPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/write-for-us" element={<WriteForUsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
